import LocationData from "@components/Locator/types/LocationData";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import analyticstracker from "@jmc/analyticstracker";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connectHits, connectStateResults } from "react-instantsearch-dom";

import { Hit } from "../Hit";
import style from "./style.module.scss";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";
import { useLocatorContext } from "../LocatorContext/LocatorContext";

interface Props {
    searchResults: { nbHits: number; hits: []; query: string };
    name?: string;
    placement?: string;
    address: string;
}

interface customHitProps {
    hits: [];
    name?: string;
    placement?: string;
}

export const MyHits = connectHits(({ hits, placement, name }: customHitProps): JSX.Element => {
    const hs = hits.map((hit: LocationData, index) => (
        <Hit key={hit.objectID} name={name} placement={`${placement}-${index}`} hit={hit as unknown as LocationData} />
    ));
    return <div id="hits">{hs}</div>;
});

const CustomResults = ({ searchResults, address, name, placement }: Props): JSX.Element => {
    const { t } = useTranslation();
    const [mapSearchTracking, setMapSearchTracking] = useState(false);
    const { specialtyFilter, distanceFilter } = useLocatorContext();

    // get filtered specialty for tracking purpose
    const filteredSpecialty =
        specialtyFilter?.length &&
        specialtyFilter
            .filter((item) => item?.isSelected)
            .map((item) => item?.label?.replace(/\(.*\)/, ""))
            .join(",");

    const ref = useRef<HTMLDivElement>(null);
    const inViewport = useOnScreen(ref);

    useEffect(() => {
        if (inViewport) {
            analyticstracker().trackEvent({
                event: EventTypes.MAP_IMPRESSION,
                info: {
                    component: "list",
                    name,
                    placement,
                },
            });
        }
    }, [inViewport]);

    useMemo(() => {
        if (searchResults) setMapSearchTracking(true);
        if (searchResults && mapSearchTracking && inViewport) {
            const distanceLabel = distanceFilter?.label ? `distance:${distanceFilter.label}` : "";
            const specialtyName = filteredSpecialty ? `specialty:${filteredSpecialty}` : "";
            const filterAttribute =
                distanceLabel && specialtyName ? `${distanceLabel}|${specialtyName}` : distanceLabel || specialtyName;
            analyticstracker().trackEvent({
                event: EventTypes.MAP_QUERY,
                info: {
                    name,
                    component: "search",
                    placement,
                    keyword: address,
                    resultcount: searchResults?.hits?.length,
                    filter: filterAttribute,
                },
            });
            setMapSearchTracking(false);
        }
    }, [searchResults, inViewport]);

    return (
        <div className={style.resultsWrapper} ref={ref}>
            {searchResults && searchResults.nbHits !== 0 ? (
                <MyHits hits={searchResults.hits} placement={placement} name={name} />
            ) : (
                <div className={style.noResults}>
                    <Typography font="title" color="gray" size="m" weight="400">
                        {t("No results found...", { ns: "common" })}
                    </Typography>
                </div>
            )}
        </div>
    );
};

export const Results = connectStateResults(CustomResults);
